import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";
import { RiDownloadCloud2Line } from "react-icons/ri";
import { verifyUploadAPI } from "../../../api/verifyAPI/verifyUploadAPI.js";

const initialSort = [
  {
    field: "row",
    dir: "asc",
  },
];

const initialDataState = {
  skip: 0,
  take: 4,
};

const voidRecord = [];
const errorRecord = [];

function VerifyRequestGridContainer({ dataGrid, setShow, setActive, error }) {
  const [values, setValues] = React.useState(voidRecord);
  const [errors, setErrors] = React.useState(errorRecord);
  const [sort, setSort] = useState(initialSort);
  const [page, setPage] = React.useState(initialDataState);

  const handleDownload = (downlaodId, type) => {
    setActive(true);
    verifyUploadAPI
      .exportExcel(downlaodId, type)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement("a");
        let fileName = `${type}List.xlsx`;

        a.style.display = "none";
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        setShow({
          status: true,
          message:
            "Si è verificato un errore durante il tentativo di importare il file.",
        });
      })
      .finally(() => {
        setActive(false);
      });
  };
  useEffect(() => {
    if (dataGrid !== undefined) {
      setValues(dataGrid);
      setErrors(error);
    }
  }, [dataGrid, error]);

  const pageChange = (event) => {
    setPage(event.page);
  };

  return (
    <>
      <Grid
        style={{
          height: "150px",
        }}
        data={orderBy(values, sort)}
        skip={page.skip}
        take={page.take}
        total={0}
        pageable={false}
        pageSize={25}
        onPageChange={pageChange}
        resizable={true}
        sortable={true}
        sort={sort}
        onSortChange={(e) => {
          setSort(e.sort);
        }}
      >
        <Column field="size" title="Totale linee esistenti" width="auto" />
        <Column
          field="match_size"
          title="Totale linee compatibili"
          width="auto"
        />
        <Column field="type" title="Oggetto di confronto" width="auto" />
        <Column
          field="download_id"
          title="Download"
          width="auto"
          cell={(props) => {
            const type = props.dataItem["type"];
            const rowValid = props.dataItem["download_id"];
            return (
              <td>
                <button
                  className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-cancel-command"
                  style={{
                    backgroundColor: "#007bff",
                    color: "#fff",
                    border: "1px solid #007bff",
                  }}
                  onClick={() => handleDownload(rowValid, type)}
                >
                  <RiDownloadCloud2Line
                    size={20}
                    style={{ marginRight: "5px" }}
                  />
                </button>
              </td>
            );
          }}
        />
      </Grid>
      <Grid
        style={{
          height: "200px",
        }}
        //data={dataGrid}
        //data={values}
        data={orderBy(errors, sort).slice(page.skip, page.take + page.skip)}
        skip={page.skip}
        take={page.take}
        total={errors.length}
        pageable={true}
        pageSize={25}
        onPageChange={pageChange}
        resizable={true}
        sortable={true}
        sort={sort}
        onSortChange={(e) => {
          setSort(e.sort);
        }}
      >
        <Column
          field="row"
          title="N° Riga"
          width="auto"
          cell={(props) => {
            const field = "row";
            const rowValid = props.dataItem["errorCode"] !== 0;
            const style = {
              backgroundColor: rowValid ? "rgb(243, 23, 0, 0.32)" : "",
            };

            return <td style={style}>{props.dataItem[field]}</td>;
          }}
        />
        <Column
          field="message"
          title="Status Message"
          width="auto"
          cell={(props) => {
            const field = "message";
            const rowValid = props.dataItem["errorCode"] !== 0;
            const style = {
              backgroundColor: rowValid ? "rgb(243, 23, 0, 0.32)" : "",
            };

            return <td style={style}>{props.dataItem[field]}</td>;
          }}
        />
      </Grid>
    </>
  );
}

export const VerifyRequestGrid = connect(
  null,
  null
)(VerifyRequestGridContainer);
